// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"cake"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 11H20V21H4V11Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M4 21H20V16H18L15 17L12 16L9 17L6 16H4V21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8 6V11M12 6V11M16 6V11M7.99805 2.99805H8.00195V3.00195H7.99805V2.99805ZM11.998 2.99805H12.002V3.00195H11.998V2.99805ZM15.998 2.99805H16.002V3.00195H15.998V2.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 21H22M4 16H6L9 17L12 16L15 17L18 16H20M4 11H20V21H4V11Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-cake')
export default class CakeIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cake',
    }
  }
}
